import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react'
import EditIcon from '@mui/icons-material/Edit';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useDispatch } from 'react-redux';

import ButtonComponent from '../../../../components/common/button/Button';
import DataTable from '../../../../components/common/datatable/DataTable';
import { updateTargetValuesData } from '../../../../redux/actions/ContractMaintenance/UpdateContract';

const DataDetails = (props) => {
  const dispatch = useDispatch();
    const [isGridReady, setIsGridReady] = useState(false);
    const [disableFilterBtn, setDisableFilterBtn] = useState(true);
    const [columnState, setColumnState] = useState(null);
    const [selectedColumn, setSelectedColumn] = useState('');
    const [selectedTV, setSelectedTV] = useState('');

    const onTVChange = (event) => {
      const selectedValue = event.target.value;
      setSelectedTV(selectedValue);

      // Get selected nodes from the grid
      let selectedNodes = [];
      if (gridApiRef.current) {
        selectedNodes = gridApiRef.current.getSelectedNodes();
      }
      if (selectedNodes.length === 0) return;

      // Update selectedTargetValue for all selected rows in the grid directly
      selectedNodes.forEach(node => {
        node.setData({ ...node.data, selectedTargetValue: selectedValue });
      });

      // Update your parent data and redux/store
      const selectedIds = new Set(selectedNodes.map(node => node.data.uniqueRowId));
      const updatedRows = props.selectedRowsData.map(row =>
        selectedIds.has(row.uniqueRowId)
          ? { ...row, selectedTargetValue: selectedValue }
          : row
      );
      if (props.setRowsData) props.setRowsData(updatedRows);
      dispatch(updateTargetValuesData(updatedRows));

      // Refresh the cells in the grid for the affected column
      if (gridApiRef.current) {
        gridApiRef.current.refreshCells({
          rowNodes: selectedNodes,
          columns: ['selectedTargetValue'],
          force: true
        });
      }
    };

    const headerItems = useMemo(() => {
        return [
              {
                headerName: "Contract Serial#",
                field: "contractSerialNumber",
                sortable: true,
                pinned: "left",
                unSortIcon: true,
                cellClassRules: {
                  'bold-cell': (params) => params.data.changedFieldNames?.includes('contractSerialNumber')
                }
              },
              {
          headerName: 'Is Update',
          field: "isUpdate",
          sortable: true,
          resizable: false,
          filterParams: {
            textFormatter: (value) => {
              if (typeof value === "string") {
                const v = value.trim().toLowerCase();
                if (v === "!") return "!";
                if (v === "-") return "-";
                return v;
              }
              return value;
            },
          },
          valueGetter: (params) => {
            if (params.data?.isUpdate === true) return "!";
            if (params.data?.isUpdate === false) return "-";
            return "";
          },
          valueFormatter: (params) => params.value,
          cellRenderer: (params) => {
            if (params.value === "!") {
              return (
                <span
                  style={{
                    fontWeight: "bold", 
                    fontSize: "20px",
                    textAlign: "center",
                  }}
                >
                  ! 
                </span>
              );
            }
            if (params.value === "-") {
              return (
                <span
                  style={{
                    color: "#616161",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  -
                </span>
              );
            }
            return "";
          },
          pinned: "left",
          unSortIcon: true,
          width: 170,
        },
              {
                headerName: "Header Level Data Fields",
                headerClass: "center-header",
                children: [
                  {
                    headerName: "Vendor Number*",
                    field: "vendorNumber",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, vendorNumber: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                     cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('vendorNumber')
          }
              },
                  {
                    headerName: "Vendor Name*",
                    field: "vendorName",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    initialWidth: 180,
                    wrapText: true,
                    autoHeight: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "paymentTerms-cell cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, vendorName: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('vendorName')
          },
                  },
                  {
                    headerName: "Agreement Type*",
                    field: "agreementType",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, agreementType: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('agreementType')
          },
                  },
                  {
                    headerName: "Agreement Date*",
                    field: "agreementDate",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, agreementDate: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('agreementDate')
          },
                  },
                  {
                    headerName: "Agreement Number*",
                    field: "agreementNumber",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, agreementNumber: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('agreementNumber')
          },
                  },
                  {
                    headerName: "Company Code*",
                    field: "companyCode",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, companyCode: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('companyCode')
          },
                  },
                  {
                    headerName: "Purchasing organization*",
                    field: "purchaseOrganisation",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, purchaseOrganisation: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('purchaseOrganisation')
          },
                  },
                  {
                    headerName: "Purchasing Group*",
                    field: "purchaseGroup",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, purchaseGroup: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('purchaseGroup')
          },
                  },
                  {
                    headerName: "Validity Start Date*",
                    field: "validityStartDate",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, validityStartDate: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('validityStartDate')
          },
                  },
                  {
                    headerName: "Validity End Date*",
                    field: "validityEndDate",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, validityEndDate: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('validityEndDate')
          },
                  },
                  {
                    headerName: "Terms of Payment key*",
                    field: "paymentTerms",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, paymentTerms: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('paymentTerms')
          },
                  },
                  {
                    headerName: "Target value for Header Area/Dist*",
                    field: "targetValue",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, targetValue: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
                      'bold-cell': (params) => params.data.changedFieldNames?.includes('targetValue')
                    },
                  },
                  {
                    headerName: "New Target value",
                    field: "newTargetValue",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                  },
                  {
                    headerName: "Selected Target Value",
                    field: "selectedTargetValue",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    cellEditor: "agSelectCellEditor",
                    cellEditorParams: {
                      values: ["", "New Target Value", "SAP Target Value"],
                    },
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, selectedTargetValue: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                      return (
                        <div className="cps-comments-icon">
                          <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                          </span>
                          {props.userRole !== "Viewer" && <ArrowDropDownIcon />}
                        </div>
                      );
                    },
                    optionalField: true,
                  },
                  {
                    headerName: "Currency Key*",
                    field: "currency",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, currency: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('currency')
          },
                  },
                  {
                    headerName: "Header Incoterms Version*",
                    field: "headIncotermVersion",
                    sortable: true,
                    resizable: false,
                    headerClass: "aft-PDT",
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, headIncotermVersion: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('headIncotermVersion')
          },
                  },
                  {
                    headerName: "Incoterms 1*",
                    field: "headIncoterms",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, headIncoterms: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('headIncoterms')
          },
                  },
                  {
                    headerName: "Header Incoterms Location 1*",
                    field: "headIncotermsLoc1",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, headIncotermsLoc1: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('headIncotermsLoc1')
          },
                  },
                  {
                    headerName: "Header Incoterms Location 2",
                    field: "headIncotermsLoc2",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, headIncotermsLoc2: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('headIncotermsLoc2')
          },
                  },
                  {
                    headerName: "Different Invoicing Party",
                    field: "invoicingParty",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, invoicingParty: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('invoicingParty')
          },
                  },
                  {
                    headerName: "Goods Supplier",
                    field: "supplyingVendor",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, supplyingVendor: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('supplyingVendor')
          },
                  },
                  {
                    headerName: "Category*",
                    field: "category",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    wrapText: true,
                    minWidth: 150,
                    cellClass: props.userRole !== "Viewer" ? "paymentTerms-cell cpsComments-cell" : "",
                    editable: props.userRole === "Viewer" ? false : true,
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, category: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                  },
                ],
                cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('category')
          },
              },
              {
                headerName: "Planned Delivery Time",
                headerClass: "center-header",
                children: [
                  {
          //           headerName: "Manufacturing LT",
          //           field: "manufacturingLeadTime",
          //           sortable: true,
          //           resizable: false,
          //           unSortIcon: true,
          //           optionalField: true,
          //           editable: props.userRole === "Viewer" ? false : true,
          //           cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
          //           valueSetter: (params) => {
          //             if (params.newValue !== params.oldValue) {
          //               const dataCopy = { ...params.data, manufacturingLeadTime: params.newValue };
          //               params.node.setData(dataCopy);
          //               return true;
          //             }
          //             return false;
          //           },
          //           cellRenderer: (params) => {
          //               return (
          //               <div className="cps-comments-icon">
          //                   <span style={{ flex: 1, padding: "0px 4px" }}>
          //                   {params.value}{" "}
          //                   </span>
          //                   {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
          //               </div>
          //               );
          //           },
          //           cellClassRules: {
          //   'bold-cell': (params) => params.data.changedFieldNames?.includes('manufacturingLeadTime')
          // },
          //         },
          //         {
          //           headerName: "IQD",
          //           field: "iqd",
          //           sortable: true,
          //           resizable: false,
          //           unSortIcon: true,
          //           optionalField: true,
          //           editable: props.userRole === "Viewer" ? false : true,
          //           cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
          //           valueSetter: (params) => {
          //             if (params.newValue !== params.oldValue) {
          //               const dataCopy = { ...params.data, iqd: params.newValue };
          //               params.node.setData(dataCopy);
          //               return true;
          //             }
          //             return false;
          //           },
          //           cellRenderer: (params) => {
          //               return (
          //               <div className="cps-comments-icon">
          //                   <span style={{ flex: 1, padding: "0px 4px" }}>
          //                   {params.value}{" "}
          //                   </span>
          //                   {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
          //               </div>
          //               );
          //           },
          //           cellClassRules: {
          //   'bold-cell': (params) => params.data.changedFieldNames?.includes('iqd')
          // },
          //         },
          //         {
                    headerName: "PDT",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    cellClass: "small-cell",
                    optionalField: true,
                    valueGetter: (params) => {
                    const manufacturingLeadTime =
                      parseFloat(params.data.manufacturingLeadTime) || 0;
                    const transitTime = parseFloat(params.data.transitTime) || 0;
                    const iqd = parseFloat(params.data.iqd) || 0;

                    const totalPDT = manufacturingLeadTime + transitTime + iqd;

                    return totalPDT;
                    },
                    cellRenderer: (params) => {
                      const manufacturingLeadTime =
                        parseFloat(params.data.manufacturingLeadTime) || 0;
                      const transitTime = parseFloat(params.data.transitTime) || 0;
                      const iqd = parseFloat(params.data.iqd) || 0;

                      const totalPDT = manufacturingLeadTime + transitTime + iqd;

                      return totalPDT;
                    },
                  },
                ],
               
              },
              {
                headerName: "Item Level Data Fields",
                headerClass: "center-header",
                children: [
                  {
                    headerName: "Item Number of Purchasing Doc*",
                    field: "itemPurchasingDocItemNo",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemPurchasingDocItemNo: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemPurchasingDocItemNo')
          },
                  },
                  {
                    headerName: "Deletion Indicator in Purchasing doc",
                    field: "itemDeletionIndicator",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemDeletionIndicator: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemDeletionIndicator')
          },
                  },
                  {
                    headerName: "Item Category in Purchasing Doc",
                    field: "itemPurchasingDocItemCategory",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    wrapText: true,
                    minWidth: 150,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell paymentTerms-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemPurchasingDocItemCategory: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemPurchasingDocItemCategory')
          },
                  },
                  {
                    headerName: "Account Assignment",
                    field: "itemAccountAssignmentCategory",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemAccountAssignmentCategory: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemAccountAssignmentCategory')
          },
                  },
                  {
                    headerName: "Material Number*",
                    field: "itemMaterialNumber",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemMaterialNumber: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemMaterialNumber')
          },
                  },
                  {
                    headerName: "Short Text",
                    field: "itemMaterialShortDesc",
                    sortable: true,
                    resizable: false,
                    initialWidth: 180,
                    wrapText: true,
                    autoHeight: true,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell paymentTerms-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemMaterialShortDesc: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemMaterialShortDesc')
          },
                  },
                  {
                    headerName: "Target Quantity*",
                    field: "itemTargetQuantity",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemTargetQuantity: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemTargetQuantity')
          },
                  },
                  {
                    headerName: "Order Unit",
                    field: "itemOrderUnit",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemOrderUnit: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemOrderUnit')
          },
                  },
                  {
                    headerName: "Net Price*",
                    field: "itemNetPrice",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemNetPrice: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemNetPrice')
          },
                  },
                  {
                    headerName: "Per*",
                    field: "itemPer",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemPer: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemPer')
          },
                  },
                  {
                    headerName: "Order Price Unit*",
                    field: "itemOrderPriceUnit",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemOrderPriceUnit: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemOrderPriceUnit')
          },
                  },
                  {
                    headerName: "Material Group",
                    field: "itemMaterialGroup",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemMaterialGroup: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemMaterialGroup')
          },
                  },
                  {
                    headerName: "Plant*",
                    field: "itemPlant",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemPlant: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemPlant')
          },
                  },
                  {
                    headerName: "Storage Location*",
                    field: "itemStorageLocation",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemStorageLocation: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemStorageLocation')
          },
                  },
                  {
                    headerName: "Order Ack Requirement*",
                    field: "itemOrderAckRequirement",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemOrderAckRequirement: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemOrderAckRequirement')
          },
                  },
                  {
                    headerName: "Material Number Used by Supplier*",
                    field: "itemSupplierMaterialNumber",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemSupplierMaterialNumber: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemSupplierMaterialNumber')
          },
                  },
                  {
                    headerName: "Incoterms Version*",
                    field: "itemIncotermVersion",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemIncotermVersion: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemIncotermVersion')
          },
                  },
                  {
                    headerName: "Incoterms*",
                    field: "itemIncoterms",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemIncoterms: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemIncoterms')
          },
                  },
                  {
                    headerName: "Incoterms Location 1*",
                    field: "itemIncotermsLoc1",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemIncotermsLoc1: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemIncotermsLoc1')
          },
                  },
                  {
                    headerName: "Incoterms Location 2",
                    field: "itemIncotermsLoc2",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, itemIncotermsLoc2: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('itemIncotermsLoc2')
          },
                  },
                ],
              },
              {
                headerName: "Pricing Data Fields",
                headerClass: "center-header",
                children: [
                  {
                    headerName: "Condition Type",
                    field: "conditionType",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, conditionType: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('conditionType')
          },
                  },
                  {
                    headerName: "Condition Amount",
                    field: "conditionAmount",
                    sortable: true,
                    optionalField: true,
                    resizable: false,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, conditionAmount: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('conditionAmount')
          },
                  },
                  {
                    headerName: "Per 1",
                    field: "pricingPer",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, pricingPer: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('pricingPer')
          },
                  },
                  {
                    headerName: "Order Price Unit",
                    field: "pricingOrderPriceUnit",
                    sortable: true,
                    optionalField: true,
                    resizable: false,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, pricingOrderPriceUnit: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('pricingOrderPriceUnit')
          },
                  },
                  {
                    headerName: "Valid From",
                    field: "validFrom",
                    sortable: true,
                    optionalField: true,
                    resizable: false,
                    unSortIcon: true,
                    cellEditorParams: {
                      placeholder: "DD-MM-YYYY",
                    },
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, validFrom: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('validFrom')
          },
                  },
                  {
                    headerName: "Valid To",
                    field: "validTo",
                    sortable: true,
                    optionalField: true,
                    resizable: false,
                    unSortIcon: true,
                    cellEditorParams: {
                      placeholder: "DD-MM-YYYY",
                    },
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, validTo: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('validTo')
          },
                  },
                  {
                    headerName: "Scale Type",
                    field: "scaleType",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, scaleType: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('scaleType')
          },
                  },
                  {
                    headerName: "Condition Scale Quantity",
                    field: "scaleQuantity",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, scaleQuantity: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('scaleQuantity')
          },
                  },
                  {
                    headerName: "Condition Scale Unit of Measure",
                    field: "scaleUOM",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, scaleUOM: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('scaleUOM')
          },
                  },
                  {
                    headerName: "Scale Amount",
                    field: "scaleAmount",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, scaleAmount: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('scaleAmount')
          },
                  },
                  {
                    headerName: "Per 2",
                    field: "pricingPer2",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, pricingPer2: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('pricingPer2')
          },
                  },
                ],
              },
              {
                headerName: "Other Details",
                headerClass: "center-header",
                children: [
                  {
                    headerName: "Prior Supplier",
                    field: "priorSupplier",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, priorSupplier: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('priorSupplier')
          },
                  },
                  {
                    headerName: "Confirmation Control Key*",
                    field: "confControl",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, confControl: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('confControl')
          },
                  },
                  {
                    headerName: "Tax Code*",
                    field: "taxCode",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, taxCode: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('taxCode')
          },
                  },
                  {
                    headerName: "Shipping Instructions*",
                    field: "shippingInstructions",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, shippingInstructions: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('shippingInstructions')
          },
                  },
          //         {
          //           headerName: "Transit Time",
          //           field: "transitTime",
          //           sortable: true,
          //           resizable: false,
          //           unSortIcon: true,
          //           optionalField: true,
          //           editable: props.userRole === "Viewer" ? false : true,
          //           cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
          //           valueSetter: (params) => {
          //             if (params.newValue !== params.oldValue) {
          //               const dataCopy = { ...params.data, transitTime: params.newValue };
          //               params.node.setData(dataCopy);
          //               return true;
          //             }
          //             return false;
          //           },
          //           cellRenderer: (params) => {
          //               return (
          //               <div className="cps-comments-icon">
          //                   <span style={{ flex: 1, padding: "0px 4px" }}>
          //                   {params.value}{" "}
          //                   </span>
          //                   {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
          //               </div>
          //               );
          //           },
          //           cellClassRules: {
          //   'bold-cell': (params) => params.data.changedFieldNames?.includes('transitTime')
          // },
          //         },
                  {
                    headerName: "Pricing Cond. Currency",
                    field: "pricingCondCurrency",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, pricingCondCurrency: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('pricingCondCurrency')
          },
                  },
                  {
                    headerName: "Forecast",
                    field: "forecast",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, forecast: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('forecast')
          },
                  },
                  {
                    headerName: "Payment in Days",
                    field: "paymentInDays",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, paymentInDays: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('paymentInDays')
          },
                  },
                  {
                    headerName: "GR time",
                    field: "goodsReceiptTime",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, goodsReceiptTime: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('goodsReceiptTime')
          },
                  },
                  {
                    headerName: "Control key for QM",
                    field: "controlKeyQM",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, controlKeyQM: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('controlKeyQM')
          },
                  },
                  {
                    headerName: "Gross weight",
                    field: "grossWeight",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, grossWeight: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('grossWeight')
          },
                  },
                  {
                    headerName: "Net weight",
                    field: "netWeight",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, netWeight: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('netWeight')
          },
                  },
                  {
                    headerName: "Weight Unit",
                    field: "weightUnit",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, weightUnit: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('weightUnit')
          },
                  },
                  {
                    headerName: "Volume",
                    field: "volume",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, volume: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('volume')
          },
                  },
                  {
                    headerName: "Volume unit",
                    field: "volumeUnit",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, volumeUnit: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('volumeUnit')
          },
                  },
                  {
                    headerName: "Underdelivery Tolerance",
                    field: "underDeliveryTolerance",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, underDeliveryTolerance: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('underDeliveryTolerance')
          },
                  },
                  {
                    headerName: "Overdelivery Tolerance",
                    field: "overDeliveryTolerance",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, overDeliveryTolerance: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('overDeliveryTolerance')
          },
                  },
                  {
                    headerName: "Unlimited Overdelivery",
                    field: "unlimitedOverDeliveryAllowed",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, unlimitedOverDeliveryAllowed: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('unlimitedOverDeliveryAllowed')
          },
                  },
                  {
                    headerName: "Min. Rem. self life",
                    field: "minRemainingShelfLife",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, minRemainingShelfLife: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('minRemainingShelfLife')
          },
                  },
                  {
                    headerName: "ERS",
                    field: "ers",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, ers: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('ers')
          },
                  },
                  {
                    headerName: "GR-based invoice verif.",
                    field: "grInvoiceVeri",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, grInvoiceVeri: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('grInvoiceVeri')
          },
                  },
                  {
                    headerName: "GR ",
                    field: "gr",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, gr: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('gr')
          },
                  },
                  {
                    headerName: "IR",
                    field: "ir",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, ir: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('ir')
          },
                  },
                  {
                    headerName: "Our Reference",
                    field: "ourReference",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, ourReference: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('ourReference')
          },
                  },
                  {
                    headerName: "Your Reference",
                    field: "yourReference",
                    sortable: true,
                    resizable: false,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, yourReference: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                        return (
                        <div className="cps-comments-icon">
                            <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                            </span>
                            {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                        );
                    },
                    cellClassRules: {
                      'bold-cell': (params) => params.data.changedFieldNames?.includes('yourReference')
                    },
                  },
                ],
              },
              {
                headerName: "Header Text",
                headerClass: "center-header",
                children: [
                  {
                    headerName: "Text 1",
                    field: "headerText1",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    cellEditor: "agTextCellEditor",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, headerText1: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                      return (
                        <div className="cps-comments-icon">
                          <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                          </span>
                          {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                      );
                    },
                  },
                  {
                    headerName: "Text 2",
                    field: "headerText2",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    cellEditor: "agTextCellEditor",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, headerText2: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                      return (
                        <div className="cps-comments-icon">
                          <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                          </span>
                          {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                      );
                    },
                  },
                ],
              },
              {
                headerName: "Header Notes",
                headerClass: "center-header",
                children: [
                  {
                    headerName: "Note 1",
                    field: "headerNote1",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    cellEditor: "agTextCellEditor",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, headerNote1: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                      return (
                        <div className="cps-comments-icon">
                          <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                          </span>
                          {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                      );
                    },
                  },
                  {
                    headerName: "Note 2",
                    field: "headerNote2",
                    sortable: true,
                    resizable: false,
                    optionalField: true,
                    unSortIcon: true,
                    editable: props.userRole === "Viewer" ? false : true,
                    cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                    cellEditor: "agTextCellEditor",
                    valueSetter: (params) => {
                      if (params.newValue !== params.oldValue) {
                        const dataCopy = { ...params.data, headerNote2: params.newValue };
                        params.node.setData(dataCopy);
                        return true;
                      }
                      return false;
                    },
                    cellRenderer: (params) => {
                      return (
                        <div className="cps-comments-icon">
                          <span style={{ flex: 1, padding: "0px 4px" }}>
                            {params.value}{" "}
                          </span>
                          {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                        </div>
                      );
                    },
                  },
                ],
              },
              {
                headerName: "Delivery Address",
                field: "deliveryAddress",
                sortable: true,
                resizable: false,
                optionalField: true,
                unSortIcon: true,
                editable: props.userRole === "Viewer" ? false : true,
                cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                cellEditor: "agTextCellEditor",
                valueSetter: (params) => {
                  if (params.newValue !== params.oldValue) {
                    const dataCopy = { ...params.data, deliveryAddress: params.newValue };
                    params.node.setData(dataCopy);
                    return true;
                  }
                  return false;
                },
                cellRenderer: (params) => {
                  return (
                    <div className="cps-comments-icon">
                      <span style={{ flex: 1, padding: "0px 4px" }}>
                        {params.value}{" "}
                      </span>
                      {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                    </div>
                  );
                },
              },
              {
                headerName: "Customer Number",
                field: "customerNumber",
                sortable: true,
                resizable: false,
                optionalField: true,
                unSortIcon: true,
                editable: props.userRole === "Viewer" ? false : true,
                cellClass: props.userRole !== "Viewer" ? "cpsComments-cell" : "",
                cellEditor: "agTextCellEditor",
                valueSetter: (params) => {
                  if (params.newValue !== params.oldValue) {
                    const dataCopy = { ...params.data, customerNumber: params.newValue };
                    params.node.setData(dataCopy);
                    return true;
                  }
                  return false;
                },
                cellRenderer: (params) => {
                  return (
                    <div className="cps-comments-icon">
                      <span style={{ flex: 1, padding: "0px 4px" }}>
                        {params.value}{" "}
                      </span>
                      {props.userRole !== "Viewer" && <EditIcon fontSize="sm" />}
                    </div>
                  );
                },
              },
              {
                headerName: "Error Details",
                field: "errorDetails",
                sortable: true,
                resizable: true,
                optionalField: true,
                unSortIcon: true,
                initialWidth: 180,
                wrapText: true,
                autoHeight: true,
                cellClass: "status-cell",
                cellRenderer: (params) => {
                  const maxLength = 50; // Maximum length before truncating
                  const text = params.value || ""; // The error details text
                  const isLongText = text.length > maxLength;
        
                  if (!params.node.showFullText) {
                    params.node.showFullText = false;
                  }
        
                  const toggleText = () => {
                    params.node.showFullText = !params.node.showFullText;
                    params.api.refreshCells({ rowNodes: [params.node], force: true }); // Refresh the cell to update the UI
                  };
        
                  return isLongText ? (
                    <div>
                      {params.node.showFullText ? (
                        <>
                          <span>{text}</span>{" "}
                          <button
                            onClick={toggleText}
                            style={{
                              background: "none",
                              border: "none",
                              color: "#181d1f",
                              cursor: "pointer",
                              textDecoration: "underline",
                              fontWeight: "bold",
                            }}
                          >
                            Less
                          </button>
                        </>
                      ) : (
                        <>
                          <span>{text.substring(0, maxLength)}...</span>{" "}
                          <button
                            onClick={toggleText}
                            style={{
                              background: "none",
                              border: "none",
                              color: "#181d1f",
                              cursor: "pointer",
                              textDecoration: "underline",
                              fontWeight: "bold",
                            }}
                          >
                            More
                          </button>
                        </>
                      )}
                    </div>
                  ) : (
                    <span>{text}</span>
                  );
                },
              },
              {
                headerName: "Status",
                field: "status",
                sortable: true,
                optionalField: true,
                resizable: false,
                initialWidth: 180,
                wrapText: true,
                autoHeight: true,
                cellClass: "paymentTerms-cell",
                unSortIcon: true,
              },
            ];
      }, [props.rowData]);
    
      const selectionColumnDef = useMemo(() => ({
          pinned: "left",
        }), []);
    
      const gridApiRef = useRef(null);

      const onColumnChange = e => {
        const col = e.target.value;
        setSelectedColumn(col);
        if (col && gridApiRef.current) {
          gridApiRef.current.ensureColumnVisible(col);
        }
      };
    
      const onGridReady = (params) => {
        gridApiRef.current = params.api; // Store the grid API instance
        setIsGridReady(true);
        if (columnState) {
          params.columnApi.applyColumnState({ state: columnState, applyOrder: true });
        }
      };
    
      useEffect(() => {
        if (isGridReady && gridApiRef?.current) {
          const savedFilterModel = localStorage.getItem("contractMaintenanceUpdateFilterModel");
          if (savedFilterModel) {
            gridApiRef.current.setFilterModel(JSON.parse(savedFilterModel));
            setDisableFilterBtn(true);
          }
        }
      }, [isGridReady]);
    
      const clearAllFilters = () => {
        if (gridApiRef.current) {
          gridApiRef.current.setFilterModel(null); // Clear all filters
          localStorage.removeItem("contractMaintenanceUpdateFilterModel");
          setDisableFilterBtn(true);
        }
      };
    
      const onFilterChanged = () => {
        if (gridApiRef.current) {
          const filterModel = gridApiRef.current.getFilterModel();
          setDisableFilterBtn(Object.keys(filterModel).length === 0); // Enable button if filters exist
          localStorage.setItem("contractMaintenanceUpdateFilterModel", JSON.stringify(filterModel));
        }
      };

      const onColumnMoved = useCallback((params) => {
        if (params && params.columnApi && typeof params.columnApi.getColumnState === "function") {
          setColumnState(params.columnApi.getColumnState());
        }
      }, []);
    
      const gridOptions = {
        getRowId: (params) => {
          return `${params?.data?.uniqueRowId}`
        },
        overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
        overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
        defaultColDef: {
          sortable: true,
          autoHeight: true,
          filter: 'agMultiColumnFilter',
          cellStyle: {
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: 1.5,
            display: "flex",
            alignItems: "center",
          },
          valueGetter: (params) => {
              if (!params.data) return "";

              const field = params.colDef.field;
              const value = params.data[field];

              return value === null || value === undefined || value === "" ? "" : value;
          },
        },
        onColumnMoved,
        onFilterChanged,
      }

  return (
    <>
      <div style={{ display: 'flex', gap: 10, justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <div style={{ display: 'flex', gap: 10 }}>
          <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
            <InputLabel>Jump to Column</InputLabel>
            <Select
              id="col-select"
              value={selectedColumn}
              label="Jump to Column"
              onChange={onColumnChange}
            >
              <MenuItem value="">Select Column</MenuItem>
              {headerItems?.flatMap(col =>
                col.children
                  ? col.children.map(child => (
                      <MenuItem key={child.field} value={child.field}>
                        {child.headerName || child.field}
                      </MenuItem>
                    ))
                  : [
                      <MenuItem key={col.field} value={col.field}>
                        {col.headerName || col.field}
                      </MenuItem>
                    ]
              )}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
            <InputLabel>Selected Target Value</InputLabel>
            <Select
              id="col-select"
              value={selectedTV}
              label="Selected Target Value"
              onChange={onTVChange}
              disabled={props.selectedRowsData?.length === 0}
            >
              <MenuItem value="">Select Option</MenuItem>
              <MenuItem value="New Target Value">New Target Value</MenuItem>
              <MenuItem value="SAP Target Value">SAP Target Value</MenuItem>
            </Select>
          </FormControl>
        </div>
        <ButtonComponent
          maxWidth="150px"
          label="Clear All Filters"
          bgColor="black"
          color="white"
          disabled={disableFilterBtn}
          onClick={clearAllFilters}
        />
      </div>
      <DataTable
        height={750}
        columns={headerItems}
        rows={props?.rowData || []}
        paginationProp={props?.pagination}
        paginationPageSize={props?.paginationPageSize}
        paginationPageSizeSelector={props?.paginationPageSizeSelector}
        onRowSelected={props.onRowSelected}
        selectionColumnDef={selectionColumnDef}
        rowSelection={props.rowSelection}
        onSelectionChanged={props.onSelectionChanged}
        onGridReady={onGridReady}
        gridOptions={gridOptions}
        getRowStyle={props.getRowStyle}
        onCellValueChanged={props.handleCellValueChange}
      />
    </>
  )
}

export default DataDetails